import React from 'react';

/**
 * Legenda delle serie: il colore è sul simbolo, il testo resta nel colore del testo.
 */
export default function Legend({ items }) {
    return (
        <ul className="stLegend">
            {
                items.map(item => (
                    <li key={item.key}>
                        <span className="stSwatch" style={{ background: item.color }} />
                        {item.label}
                    </li>
                ))
            }
        </ul>
    );
}
